import {
  BreakpointDetection_default
} from "../chunk-HZQII37Y.js";
import {
  __spreadValues
} from "../chunk-BBZEL7EG.js";

// src/ThemeProvider/index.tsx
import { lazyLoad } from "@levana/utils/lazyLoad";
import CssBaseline from "@mui/joy/CssBaseline";
import GlobalStyles from "@mui/joy/GlobalStyles";
import { CssVarsProvider } from "@mui/joy/styles";
import { useEffect, useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var ThemeProvider = (props) => {
  const { children } = props;
  return /* @__PURE__ */ jsx(ThemeSelector, { brandId: props.brandId, children: (cssVarsData) => /* @__PURE__ */ jsxs(
    CssVarsProvider,
    {
      theme: cssVarsData.theme,
      defaultMode: cssVarsData.defaultMode,
      children: [
        /* @__PURE__ */ jsx(CssBaseline, {}),
        /* @__PURE__ */ jsx(
          GlobalStyles,
          {
            styles: {
              "#root": __spreadValues({
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                flexWrap: "nowrap"
              }, props.brandId === "rujira" && {
                background: `linear-gradient(180deg, ${cssVarsData.theme.vars.palette.background.body} 0, #0f1117 500px)`
              }),
              ul: {
                paddingInlineStart: "1.5rem"
              }
            }
          }
        ),
        /* @__PURE__ */ jsx(BreakpointDetection_default, {}),
        children
      ]
    }
  ) });
};
var ThemeSelector = (props) => {
  var _a;
  const [cssVarsData, setCssVarsData] = useState();
  useEffect(() => {
    switch (props.brandId) {
      case "levana":
        lazyLoad(() => import("./levana.js")).then(setCssVarsData);
        break;
      case "rujira":
        lazyLoad(() => import("./rujira.js")).then(setCssVarsData);
        break;
    }
  }, [props.brandId]);
  if (!cssVarsData) {
    return null;
  }
  return (_a = props.children) == null ? void 0 : _a.call(props, cssVarsData);
};
var ThemeProvider_default = ThemeProvider;
export {
  ThemeProvider_default as default
};
